import React from 'react';
import tokens from '@veneer/tokens';
import { useTheme } from '@veneer/theme';
var useColorSchemeHelper = (colorScheme, isTint) => {
  var theme = useTheme();
  var isContrast = theme.mode === 'contrast';
  return React.useMemo(() => {
    var getMainTheme = () => {
      if (isContrast) return 'contrast';
      if (isTint) return 'tint';
      return 'shade';
    };
    var mainTheme = {
      shade: {
        background: tokens.color["".concat(colorScheme, "7")],
        hover: tokens.color["".concat(colorScheme, "8")],
        active: tokens.color["".concat(colorScheme, "9")],
        foreground: tokens.color.white,
        clearIcon: tokens.color.white,
        clearButtonHover: tokens.color.white,
        clearButtonActive: tokens.color.white,
        borderColor: 'transparent'
      },
      tint: {
        background: tokens.color["".concat(colorScheme, "3")],
        hover: tokens.color["".concat(colorScheme, "4")],
        active: tokens.color["".concat(colorScheme, "5")],
        foreground: tokens.color.gray12,
        clearIcon: tokens.color.gray12,
        clearButtonHover: tokens.color.gray12,
        clearButtonActive: tokens.color.gray12,
        borderColor: 'transparent'
      },
      contrast: {
        background: 'transparent',
        hover: tokens.color.highContrastPink,
        active: tokens.color.highContrastBlue,
        foreground: tokens.color.white,
        clearIcon: tokens.color.highContrastYellow,
        clearButtonHover: tokens.color.highContrastEigengrau,
        clearButtonActive: tokens.color.highContrastEigengrau,
        borderColor: tokens.color.white
      }
    };
    return mainTheme[getMainTheme()];
  }, [colorScheme, isContrast, isTint]);
};
export default useColorSchemeHelper;